import React, { useEffect, useContext } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { TableRow } from '@material-ui/core'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { DailyMonitoringDetailsFiltersContext } from '../../../../../../context/DailyMonitoringDetailsFiltersContext'
import EmptyCells from '../../../../../../components/EmptyCells'
import DefaultTableCellSmallSpace from '../../../../../../components/DefaultTableCellSmallSpace'
import { GET_ORDERS_AVERAGE_HISTORY } from '../../../../../../queries/dailyMonitoringCancelled'
import { formatCurrency, getDaysInMonth, DaysInMonth } from '../../../../../../utils/Helpers'
import { defaultFormatMonthTimeZone } from '../../../../../../utils/consts'

const title = 'Ticket médio'
export default function DailyOrdersAverage (): JSX.Element {
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_ORDERS_AVERAGE_HISTORY, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const createdAt: any = {
      initialDate: `${filters.date.year}-${filters.date.month}||/M`,
      finalDate: `${filters.date.year}-${filters.date.month}||/M`,
      ...defaultFormatMonthTimeZone
    }

    getData({
      variables: { filters: { states: filters.states, cities: filters.cities, createdAt } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <EmptyCells title={title} />
  if (loading || !data) return <EmptyCells title={title} />
  if (error) return <EmptyCells title={title} />
  if (!data.ordersAggs?.aggregations?.salesOverTime) return <EmptyCells title={title} />

  const { buckets } = data.ordersAggs?.aggregations?.salesOverTime
  return (
    <TableRow>
      <DefaultTableCellSmallSpace style={{ fontSize: 12, backgroundColor: '#f5f5f5' }}>{title}</DefaultTableCellSmallSpace>
      {getDaysInMonth(filters.date.year, filters.date.month).map((day: DaysInMonth) => {
        const bucket = buckets.filter((b: any) => moment.parseZone(String(b.key_as_string)).isSame(moment(day.date, 'DD/MMM/YYYY'), 'day'))[0]
        return !isEmpty(bucket) ? <DefaultTableCellSmallSpace style={{ fontSize: 12, backgroundColor: '#f5f5f5' }} key={bucket.key_as_string}>{formatCurrency(bucket.total.value, 2)}</DefaultTableCellSmallSpace> : <DefaultTableCellSmallSpace>-</DefaultTableCellSmallSpace>
      })}
    </TableRow>
  )
}
